import { getQuiz, submitQuiz } from "@/lib/api";
import type { SubmitQuizRequest } from "@/lib/api-types";
import { queryKeys } from "@/lib/query-keys";
import { useMutation, useQuery } from "@tanstack/react-query";

export function useQuiz(moduleId: string) {
	const query = useQuery({
		queryKey: queryKeys.quiz(moduleId),
		queryFn: () => getQuiz(moduleId),
		enabled: !!moduleId,
	});

	const submit = useMutation({
		mutationFn: (body: SubmitQuizRequest) => submitQuiz(moduleId, body),
	});

	return { quiz: query.data, isLoading: query.isLoading, submit };
}
